var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"fixed-width-tweak-upper"},[_c('div',{staticClass:"row xs-f-small max-at-tweak"},[_c('div',{staticClass:"xs-12"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }